<template lang="html">
  <div class="full-height-page">
    <div class="content-wrapper">
      <!-- Partial: Stepper Navigation -->
      <v-stepper v-model="currentStepIndex" class="stepper">
        <!-- Partial: Stepper header -->
        <nav class="stepper__header">
          <v-stepper-header>
            <v-layout class="header-container">
              <template v-for="(step, index) in steps">
                <v-stepper-step
                  :complete="currentStepIndex > index + 1"
                  :editable="currentStepIndex > index + 1"
                  :step="index + 1"
                  edit-icon="done"
                  @click="goToStep(index + 1)"
                >
                  {{ step.name }}
                </v-stepper-step>
                <v-divider v-if="index !== steps.length - 1"></v-divider>
              </template>
            </v-layout>
          </v-stepper-header>
        </nav>
      </v-stepper>

      <!-- Partial: Stepper content -->
      <div v-if="currentStep">
        <ReviewAndDownloadK1Step
          v-if="currentStep.key === 'review-and-download'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ReviewAndDownloadK1Step from './ReviewAndDownloadK1Step';

export default {
  components: {
    ReviewAndDownloadK1Step,
  },

  data() {
    return {
      currentStepIndex: 0,
      steps: [
        {
          key: 'review-and-download',
          name: 'Review and Download Your K-1 Package',
        },
      ],
    };
  },

  computed: {
    currentStep() {
      if (this.currentStepIndex === 0) return;
      return this.steps[this.currentStepIndex - 1];
    },
  },

  methods: {
    goToStep(step) {
      if (this.currentStepIndex < step) {
        return;
      }

      this.currentStepIndex = step;
    },
  },
};
</script>

<style lang="css" scoped>
.full-height-page {
  min-height: 100dvh;

  background-color: var(--gray-0);
}

.content-wrapper {
  width: 100%;
}

.stepper {
  position: sticky;
  top: 0;
  z-index: 1;
}

.stepper__header {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0 16px !important;
}

.v-stepper__header {
  box-shadow: 0 0 0 transparent;
}
</style>
